{
  "ApiKeys_AddMode": "U moet eerst een gebruiker aanmaken voordat u een API-sleutel kunt aanmaken.",
  "ApiKeys_Add_New": "Nieuwe API-sleutel toevoegen...",
  "ApiKeys_RevokeButton": "Herroepen",
  "ApiKeys_RemoveButton": "Verwijderen",
  "ApiKeys_TableHeader_Name": "Naam",
  "ApiKeys_TableHeader_Expiry": "Vervaldatum",
  "ApiKeys_TableHeader_Created": "Gemaakt",
  "ApiKeys_TableHeader_LastAccessed": "Laatst geraadpleegd",
  "ApiKeys_TableHeader_Title": "API-sleutels",
  "ApiKeys_Validations_Required": "Vereist",
  "ApiKeys_Name_Validations_MaxLength": "Maximale lengte is 50",
  "ApiKeys_Revoke_ConfirmMessage": "Weet u zeker dat u deze API-sleutel wilt intrekken?",
  "ApiKeys_Revoke_Confirm": "Bevestigen",
  "ApiKeys_Revoke_Cancel": "Annuleren",
  "ApiKeys_Indefinite": "Nooit",
  "ApiKeys_Expired": "Verlopen",
  "ApiKeys_Placeholder_Description": "Beschrijving",
  "ApiKeys_KeyDisplay_Title": "Toegangstoken aangemaakt: \"{}\"",
  "ApiKeys_KeyDisplay_SubTitle": "Sla dit token op een veilige plek op, zodat het niet meer bekeken of opgehaald kan worden zodra u dit venster sluit of een andere sleutel toevoegt.",
  "ApiKeys_Copy_Success": "Gekopieerd naar klembord",
  "ApiKeys_Copy_Fail": "Kopiëren naar klembord mislukt",
  "ApiKeys_MaxAPIKeysReached": "U hebt het maximale aantal API-sleutels bereikt. Verwijder een bestaande sleutel voordat u een nieuwe kunt aanmaken.",
  "NAME": "ApiKeys"
}